<template>
<div class="intro-wrap">
	<y-teacher-info></y-teacher-info>
	<y-nav></y-nav>
	<div class="intro-content main">
		<section v-if="desc" v-html="desc"></section>
		<section class="center" style="color: #666; line-height: 200px;" v-else>该老师还未写好介绍语</section>
	</div>
	<!-- 底部推荐 -->
  <y-elite-introduce></y-elite-introduce>
  <!-- 底部推荐 over -->
</div>
</template>

<script>
import { mapActions } from 'vuex'
import YTeacherInfo from '@/components/TeacherInfo'
import YNav from '@/components/Nav'
import YEliteIntroduce from '@/components/room/EliteIntroduce'

export default {
	name: 'intro',
	
	asyncData ({ params, store, error, $axios }) {
		// 初始化老师数据
		let desc = null
		return $axios._get('/Teacher/Introduce', { id: params.id }).then(res => {
			return {
				desc: res.sign
			}
		})
	},
	mounted () {
		this.$store.dispatch('getAd', ['roomTopLeftNormal', 'roomBottomImageNormal'])
	},
	components: {
  	YTeacherInfo,
		YNav,
		YEliteIntroduce
	}
}
</script>

<style lang="less">
.intro-wrap {
	padding: 20px 0; background-color: #e3e3e3;
	.intro-content { background-color: #fff; padding: 40px; margin-bottom: 20px;
		li { padding-bottom: 12px;
			h3 { font-size: 16px; line-height: 2; color: #333; background-color: #eee; }
			p { padding: 6px; }
		}
	}
}
</style>
